import { createContext, useContext, useState } from "react";
import CryptoUtils from "../../util/cryptoUtils";

const ClusterContext = createContext();

export const ClusterProvider = ({ children }) => {
    const [selectedClusters, setSelectedCluster] = useState(() => {
        const storedCluster = CryptoUtils.getFromLocalStorage("clusterName");
        return storedCluster ? JSON.parse(storedCluster) : [];
    });

    const updateCluster = (clusterId, clusterName) => {
        const clusterArray = [{ clusterId, clusterName }]; // Store as array
        setSelectedCluster(clusterArray);
        CryptoUtils.saveToLocalStorage("clusterName", JSON.stringify(clusterArray));
    };

    return (
        <ClusterContext.Provider value={{ selectedClusters, updateCluster }}>
            {children}
        </ClusterContext.Provider>
    );
};

export const useCluster = () => useContext(ClusterContext);
